import { Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth.store';

export function CustomerSelect() {
  const { customers, selectCustomer } = useAuthStore();
  const navigate = useNavigate();

  const handleSelectCustomer = async (customer: typeof customers[0]) => {
    await selectCustomer(customer);
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl font-bold text-white">L</span>
          </div>
          <h1 className="text-2xl font-bold text-slate-800">Select Customer</h1>
          <p className="text-slate-600 mt-2">
            Choose which organization you want to work with
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          {customers.map((customer, index) => (
            <button
              key={customer.id}
              onClick={() => handleSelectCustomer(customer)}
              className={`w-full flex items-center gap-4 p-4 text-left hover:bg-slate-50 transition-colors ${
                index > 0 ? 'border-t border-slate-200' : ''
              }`}
            >
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                <Building2 size={20} className="text-blue-600" />
              </div>
              <div>
                <h3 className="font-medium text-slate-800">{customer.name}</h3>
                {customer.organizationNumber && (
                  <p className="text-sm text-slate-500">
                    Org: {customer.organizationNumber}
                  </p>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CustomerSelect;
